export default {
  AS: {
    "footer.button.billOfMaterials": "Parts list",
    "footer.button.export": "Export",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Sales Contact",
    "footer.button.addToWatchlist": "Add to favorites",
    "footer.button.requestQuote": "Request quote",
    "header.configurator.title": "Configurator",

    "header.links.about.label": "About asecos",
    "header.links.about.url":
      "https://www.asecos.com/About-asecos/About-asecos/About-asecos/EN_index_3187.html",
    "header.links.terms.label": "GTC",
    "header.links.terms.url":
      "https://www.asecos.com/GTC-asecos-Ltd/EN_index_3212.html",
    "header.links.imprint.label": "Imprint",
    "header.links.imprint.url":
      "https://www.asecos.com/Imprint/EN_index_1438.html",
    "header.links.privacy.label": "Privacy Policy",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/EN/GB/pivacy-policy",

    "dialog.requestQuote.title.success": "Request sent",
    "dialog.requestQuote.title.requestQuote": "Request quotes",
    "tab.billOfMaterials.title": "Bill of materials",
    "tab.configurationSummary.title": "Configuration summary",
    "dialog.requestQuote.title.contactData": "Contact details",
    "dialog.requestQuote.title.companyData": "Company details",
    "dialog.requestQuote.label.salutation": "Title",
    "dialog.requestQuote.select.salutation.option.female": "Ms.",
    "dialog.requestQuote.select.salutation.option.male": "Mr.",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "First name",
    "dialog.requestQuote.label.lastName": "Last name",
    "dialog.requestQuote.label.email": "Email",
    "dialog.requestQuote.label.phone": "Phone",
    "dialog.requestQuote.label.company": "Company",
    "dialog.requestQuote.label.country": "Country",
    "dialog.requestQuote.label.postalCode": "Zip code",
    "dialog.requestQuote.label.city": "City",
    "dialog.requestQuote.label.street": "Street",
    "dialog.requestQuote.label.number": "No.",
    "dialog.requestQuote.label.contactHours": "Please call me back",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Morning",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Afternoon",
    "dialog.requestQuote.label.specialistRetailer.header":
      "If you have a preferred retailer, please register them here",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Title",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Ms.",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Mr.",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Company",
    "dialog.requestQuote.label.specialistRetailer.firstName": "First name",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Last name",
    "dialog.requestQuote.label.specialistRetailer.email": "Email",
    "dialog.requestQuote.label.specialistRetailer.city": "City",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/EN/GB/pivacy-policy",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/EN/GB/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=EN",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "I have read the <privacyLink>privacy policy</privacyLink> and accept it. Furthermore, I consent to the processing, use and disclosure of my data to a specialist dealer in <consentLink>accordance with the consent.</consentLink>.",
    "dialog.requestQuote.label.comment": "Comment",
    "SubconfigurationNavigation.resetItem": "Reset group",
    "SubconfigurationNavigation.previousItem": "Back",
    "SubconfigurationNavigation.nextItem": "Next",
    "form.field.error.email": "Email invalid",
    "form.field.error.phone": "Phone number invalid",
    "validation.required": "This field is required",
    "footer.button.save": "Save",
    "footer.button.load": "Load",

    "dialog.requestQuote.success.message":
      "Thank you for your interest in asecos and our products. In the next few minutes, you will receive a confirmation email at the address you provided, including your configuration data as a PDF and JSON file. You can use the latter to reopen your configuration via the upload button. asecos products are sold through authorized dealers. We will therefore forward your request to a suitable asecos partner. They will prepare a non-binding quote based on your configuration and contact you if necessary.",
    "dialog.requestQuote.success.close": "Close",
    "dialog.requestQuote.error.message":
      "An error occurred while sending your request. Please try again later.",
  },
};
